var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewSessionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FF7300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 19.7917H15.6667C15.3251 19.7917 15.0417 19.5084 15.0417 19.1667C15.0417 18.825 15.3251 18.5417 15.6667 18.5417H21.5001C21.8417 18.5417 22.1251 18.825 22.1251 19.1667C22.1251 19.5084 21.8417 19.7917 21.5001 19.7917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3167 23.125H15.6667C15.3251 23.125 15.0417 22.8417 15.0417 22.5C15.0417 22.1583 15.3251 21.875 15.6667 21.875H19.3167C19.6584 21.875 19.9417 22.1583 19.9417 22.5C19.9417 22.8417 19.6584 23.125 19.3167 23.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 14.625H17.3334C16.5334 14.625 15.0417 14.625 15.0417 12.3334C15.0417 10.0417 16.5334 10.0417 17.3334 10.0417H20.6667C21.4667 10.0417 22.9584 10.0417 22.9584 12.3334C22.9584 13.1334 22.9584 14.625 20.6667 14.625ZM17.3334 11.2917C16.5084 11.2917 16.2917 11.2917 16.2917 12.3334C16.2917 13.375 16.5084 13.375 17.3334 13.375H20.6667C21.7084 13.375 21.7084 13.1584 21.7084 12.3334C21.7084 11.2917 21.4917 11.2917 20.6667 11.2917H17.3334Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 27.9583H16.5C11.8167 27.9583 10.875 25.8083 10.875 22.3333V17.3333C10.875 13.5333 12.25 11.9083 15.6333 11.7333C15.9667 11.7167 16.275 11.975 16.2917 12.325C16.3083 12.675 16.0417 12.9583 15.7 12.975C13.3333 13.1083 12.125 13.8167 12.125 17.3333V22.3333C12.125 25.4166 12.7333 26.7083 16.5 26.7083H21.5C25.2667 26.7083 25.875 25.4166 25.875 22.3333V17.3333C25.875 13.8167 24.6667 13.1083 22.3 12.975C21.9583 12.9583 21.6917 12.6583 21.7083 12.3167C21.725 11.975 22.025 11.7083 22.3667 11.725C25.75 11.9083 27.125 13.5333 27.125 17.325V22.325C27.125 25.8083 26.1833 27.9583 21.5 27.9583Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSessionIcon);
export default __webpack_public_path__ + "static/media/newSessionIcon.6643b7b8202acf4f2f65688bd68ba74b.svg";
export { ForwardRef as ReactComponent };